export const PHOTOS_BATCH_SIZE = 30;

export const TOP_PHOTOS_SIZE = 12;
